export function getLabelFromArrayByParameter (value, array, parameter, label = 'label') {
  return array.find(item => item[parameter] === value)[label]
}

export function formatMerchantLimitMessage (client, clientBalance, t) {
  if (client?.debtLimit === undefined || clientBalance?.balance?.balanceOfInvolvement?.amount === undefined) {
    return ''
  }

  return `${t('order.merchantLimit')}: 
          ${clientBalance?.balance?.balanceOfInvolvement?.amount} / 
          ${client?.debtLimit}.`
}
